import { TActions } from '../../../AppModulesWrapper';

import {
  CHANGE_CURRENT_OVER_PACKAGE_BET,
  CHANGE_CURRENT_OVER_SERVICE_BET,
  CHANGE_AUCTION_BET_STEPS,
} from '../../actions/auction';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../actions/publishTerms';
import { RESET_STATE } from '../../actions/resetState';
import { IAuctionState } from '../../types/reducers/auction';
import { auctionDefaultState } from './defaultState';

export function auction(state: IAuctionState = auctionDefaultState, action: TActions): IAuctionState {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      const { auction } = action.payload;
      const currentOverPackageBet = state.currentOverPackageBet || auction.currentOverPackageBet;
      const currentOverServiceBet = state.currentOverServiceBet || auction.currentOverServiceBet;

      return {
        ...state,
        ...auction,
        currentOverPackageBet,
        currentOverServiceBet,
      };
    }

    case CHANGE_CURRENT_OVER_PACKAGE_BET:
      return {
        ...state,
        isBetChanged: true,
        currentOverPackageBet: action.payload,
      };

    case CHANGE_CURRENT_OVER_SERVICE_BET:
      return {
        ...state,
        isBetChanged: true,
        currentOverServiceBet: action.payload,
      };

    case CHANGE_AUCTION_BET_STEPS:
      return {
        ...state,
        previousBets: action.payload.previousBets,
        nextBets: action.payload.nextBets,
      };

    case RESET_STATE:
      return {
        ...auctionDefaultState,
      };

    default:
      return state;
  }
}
